import React from 'react'
import PropTypes from 'prop-types'
const Table = (props) => {

    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.3333 2H3.33333C2.6 2 2 2.6 2 3.33333V12.6667C2 13.4 2.6 14 3.33333 14H13.3333C14.0667 14 14.6667 13.4 14.6667 12.6667V3.33333C14.6667 2.6 14.0667 2 13.3333 2ZM13.3333 3.33333V5.33333H3.33333V3.33333H13.3333ZM10 12.6667H6.66667V6.66667H10V12.6667ZM3.33333 6.66667H5.33333V12.6667H3.33333V6.66667ZM11.3333 12.6667V6.66667H13.3333V12.6667H11.3333Z" fill={props.fill}/>
        </svg>
    )
}
Table.propTypes = {
    fill: PropTypes.string
}
export default Table
